import script from "./spinner.vue?vue&type=script&setup=true&lang=js"
export * from "./spinner.vue?vue&type=script&setup=true&lang=js"

import "./spinner.vue?vue&type=style&index=0&id=4da08b5c&lang=scss"

const __exports__ = script;

export default __exports__